import moment from 'moment';

export function doStrategiesOverlap({
  anniversaryStartsAt,
  anniversaryEndsAt,
  startsAt,
  endsAt
}: {
  anniversaryStartsAt?: Date;
  anniversaryEndsAt?: Date;
  startsAt?: Date;
  endsAt?: Date;
}): boolean {
  if (!anniversaryStartsAt || !anniversaryEndsAt || !startsAt || !endsAt) {
    return false;
  }

  const anniversaryStart = moment(anniversaryStartsAt);
  const anniversaryEnd = moment(anniversaryEndsAt).endOf('day');
  const regularStart = moment(startsAt);
  const regularEnd = moment(endsAt).endOf('day');

  const isOverlap =
    anniversaryStart.isSameOrBefore(regularEnd) && anniversaryEnd.isSameOrAfter(regularStart);

  return isOverlap;
}
